var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLocalAreaIcon = function SvgLocalAreaIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74.79,
    height: 86.599,
    viewBox: "0 0 74.79 86.599",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ca0928;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M709.459,846.472v11.809h11.809v7.872H709.459v11.809h-7.872V866.154H689.778v-7.872h11.809V846.472Zm-31.491,47.236a7.873,7.873,0,1,1,7.873-7.872A7.9,7.9,0,0,1,677.969,893.708Zm3.937-39.127v7.951a25.728,25.728,0,0,0-3.937-.315c-13.187,0-23.618,10.116-23.618,24.405,0,9.211,7.676,21.414,23.618,35.978,15.942-14.565,23.618-26.728,23.618-35.978v-.787h7.872v.787q0,19.6-31.491,46.449-31.471-26.866-31.491-46.449c0-19.6,14.958-32.278,31.491-32.278A32.46,32.46,0,0,1,681.905,854.581Z",
    transform: "translate(-646.478 -846.472)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocalAreaIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/local-area-icon.f409f7b6.svg";
export { ForwardRef as ReactComponent };